<template>
	<div class="Monthlyenergy">
		<div class="title">
			<img src="../../../assets/img/logo.png" alt="">
			<span>每月耗能趋势</span>
		</div>
		<div id="Monthlyenergyecharts" @mouseover="stop()" @mouseleave="start()">
			
		</div>
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
	  	return{
			quantity:[180,210,170,310,210,300],
			water:[300,150,210,180,350,400],
			month:['1月','2月','3月','4月','5月','6月'],
			timer:'',
			energyConsumption:'',
		}
	  },
	  methods: {
	  fontSize(res,initWidth=1920){
					var nowClientWidth = document.documentElement.clientWidth;
					return res*(nowClientWidth/initWidth);
				},
	   echartsLoop(echartsName=this.energyConsumption,time) {
	       var currentIndex = -1;
	       this.timer=setInterval(function () {
	         var dataLen = echartsName._model.option.series[0].data.length;
	         // 取消之前高亮的图形
	         echartsName.dispatchAction({
	           type: "downplay",
	           seriesIndex: 0, //表示series中的第几个data数据循环展示
	           dataIndex: currentIndex,
	         });
	         currentIndex = (currentIndex + 1) % dataLen; //+1表示每次跳转一个
	         // 高亮当前图形
	         echartsName.dispatchAction({
	           type: "highlight",
	           seriesIndex: 0,
	           dataIndex: currentIndex,
	         });
	         // 显示 tooltip
	         echartsName.dispatchAction({
	           type: "showTip",
	           seriesIndex: 0,
	           dataIndex: currentIndex,
	         });
	       }, time);
	   },
	   echartsLine(){
		   var echarts = require('echarts');
		   let energyConsumption = echarts.init(document.getElementById('Monthlyenergyecharts'));
		   energyConsumption.setOption({
			    xAxis: {
				   type: 'category',
				   boundaryGap: false,
				   axisLine: {
				         show: true,
				         lineStyle: {
				           color: "rgba(255, 255, 255,.5)",
						   width: 1
				         },
				       },
					axisLabel: {
					      show: true,
					      color: "#FFFFFF",
						  fontSize: this.fontSize(13)
					},
				   axisTick: {
				         show: false
				   },
				   data:this.month
			    },
				tooltip: {
				    axisPointer: {
				          type: "line"
				        },
				    trigger: "axis",
				    show: true
				},
				yAxis:[
					{
						type: 'value',
						name: "kw",
						min: 0,
						minInterval: 100,
						interval: 100,
						nameLocation: "end",
						position: "left",
						nameGap: 30,
						nameTextStyle: {
						      color: "#FFFFFF",
							  fontSize: this.fontSize(13),
							  align: "right",
							  verticalAlign: "middle",
							  padding: [0, 7, 0, 0]
						    },
						axisLine: {
						      show: false,
						},
						axisLabel: {
						      show: true,
							   fontSize: this.fontSize(13),
						      color: "#FFFFFF"
						},
						splitLine: {
						      show: true,
						      lineStyle: {
						        color: "rgba(255, 255, 255, 1)",
								type: "dashed",
						      }
						},
					},
					{
						type:'value',
						name: "m³",
						min: 0,
						minInterval: 100,
						interval: 100,
						nameLocation: "end",
						position: "right",
						nameGap: 30,
						nameTextStyle: {
						      color: "#FFFFFF",
							  fontSize:this.fontSize(13),
							  align: "left",
							  verticalAlign: "middle",
							  padding: [0, 0, 0, 9]
						    },
						axisLine: {
						      show: false,
						},
						axisLabel: {
						      show: true,
						      color: "#FFFFFF",
							   fontSize: this.fontSize(13),
						},
						splitLine: {
						      show: true,
						      lineStyle: {
						        color: "rgba(25, 39, 52, .7)",
								type: "dashed",
						      }
						},
					}
				] ,
				legend: {
					show:true,
				    top: "6%",
					itemStyle: {
					      
					},
					textStyle: {
					      color: "#ffffff",
						  fontSize:this.fontSize(13),
					},
					
				  },
				grid: {
				    show: false,
				    left: "10%",
					top: "30%",
					right: "10%",
					bottom: "10%"
				  },
				series: [
				  {
					type: 'line',
					name:'耗电总量',
					symbolSize: 0,
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: "rgba(96, 189, 243,1)"
									},
									{
										offset: 0.8,
										color: "rgba(96, 189, 243,0.1)"
									}
								],
								false
							),
						}
					},
					data: this.water,
					yAxisIndex:0
				 },
				 {
					type: 'line',
					name:'用水总量',
					symbolSize: 0,
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: "rgba(141, 253, 253,1)"
									},
									{
										offset: 0.8,
										color: "rgba(141, 253, 253,0.1)"
									}
								],
								false
							),
						}
					},
					data: this.quantity,
					yAxisIndex:1
				 }
				]
		   });
		   window.addEventListener("resize", () => {
		     energyConsumption.resize();
		   });
		   this.echartsLoop(energyConsumption,2000)
	   },
	   stop(){
		   var echarts = require('echarts');
		   this.energyConsumption = echarts.init(document.getElementById('Monthlyenergyecharts'));
		   clearInterval(this.timer)
	   },
	   start(){
		   this.echartsLoop(this.energyConsumption,2000)
	   }
	  },
	  mounted() {
	     this.echartsLine();
		 
	  }
	};
</script>

<style scoped="scoped">
	.Monthlyenergy{
		width: 100%;
		height: 35%;
	}
	#Monthlyenergyecharts{
		width: 100%;
		height: calc(100% - 4vh);
	}
</style>
